import { MAX_COMBINED_FACET } from "../constants/grid.constant";
import { getPageViewType } from "../helpers/gtm.helper";
import { CombinedFacets, GridType } from "../model/grid.model";

export const isPageHasChanged = (
    gridType: GridType,
    previousPageHasChanged: boolean,
): boolean => !!(gridType !== "search" && previousPageHasChanged === false);

export const getPageViewTypeOnGrid = (
    combinedFacets: CombinedFacets[],
    hasFacetName: boolean,
    isMissingFacet: boolean | undefined,
): string => {
    let pageViewType;
    if (combinedFacets.length === MAX_COMBINED_FACET) {
        pageViewType = getPageViewType(isMissingFacet)["facets"];
    } else if (combinedFacets.length === 1 || hasFacetName) {
        pageViewType = getPageViewType(isMissingFacet)["facet"];
    } else {
        pageViewType = getPageViewType(isMissingFacet)["category"];
    }

    return pageViewType;
};
